







import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PoliciesCompany extends Vue {
  get privacyPolicyUrl(): string {
    if (this.$store.state.profile.pais === 'BR') {
      return 'https://community.test.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-TEST/ta-p/727913';
    }
    return 'https://community.test.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-TEST/ta-p/567941';
  }
}
